// @ts-ignore
import txt from '!!raw-loader!../../images/logo.svg';
import * as React from 'react';
import { AnimatedSVGWidget } from './AnimatedSVGWidget';
export const AnimatedLogoWidget = (props) => {
    return React.createElement(AnimatedSVGWidget, Object.assign({}, props, { svgData: txt }));
};
